import React from 'react';
import EditProfile from '../../Components/Profile/EditProfile';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';

const EditProfilePage = () => {
  return (
    <>
      <AppHeader title="editProfile" goBack />
      <StyledDiv
        id="notification-container"
        height={'calc(100vh - 60px)'}
        overflow={'auto'}>
        <EditProfile />
      </StyledDiv>
    </>
  );
};

export default EditProfilePage;
